import React, { useState, Fragment, useContext} from "react";
import "../../../../../ui-styles/list/contactListAction.css";
import DeleteConfirmModal from "../DeleteConfirmModal";
import { useHistory } from 'react-router-dom';
import { deleteUser } from "../../../../../actions/users";
import { LangCtx } from "../../../../../lib/context";
// import Button from "../../../../../lib/ui/buttons/Button";
import VerifyPopup from "../VerifyPopup";
import "../../../../../ui-styles/tooltips/tooltips.css";

const ClinicListItem = (props) => {
    const { l } = useContext(LangCtx);
    // const { role } = useContext(RoleCtx);
    const [msg, setMsg] = useState(null)
    const history = useHistory();

    const { data } = props;
    // const [verify, setVerify] = useState(data.verify ? true: false);
    const [openDelete, setOpenDelete] = useState(false)
    const [openPopup, setopenPopup] = useState(false)

    const handleOpen = () => {
        setOpenDelete(prevState => !prevState);
    }
    const handleVerify = () => {
        // setVerify(prevState => !prevState);
        setopenPopup(prevState => !prevState);
    }

    const handlePopup = () => {
        setopenPopup(prevState => !prevState);
    }

    const handleDelete = () => {
        // setLoading(true);
        deleteUser({ username: props.data.userId, consultRole: props.data.consultRole }).then(res => {
            //  setLoading(false);
            if (res && res.status) {
                if (res.data && (res.data.doctorCount > 0 || res.data.patientCount > 0)) {
                    if (res.data.doctorCount > 0 && res.data.doctorCount)
                        // setMsg('This clinic is having ' + res.data.doctorCount + ' doctors and ' + res.data.patientCount + ' Patients.' + ' Please delete doctors and patients under this clinic, to delete.')
                    setMsg(`This clinic is having ${res.data.doctorCount} doctors and ${res.data.patientCount} patients. Please delete doctors and patients under this clinic to delete.`)
                    else if (res.data.doctorCount > 0)
                        setMsg(`This clinic is having ${res.data.doctorCount} doctors, Please delete doctors under this clinic, to delete.`)
                    else if (res.data.patientCount > 0)
                        setMsg(`This clinic is having ${res.data.patientCount} Patients. Please delete patients under this clinic, to delete.`)
                }
                else {
                    props.reloadData();
                }
            }
        }).catch(err => {
            //  setLoading(false);
            console.log("err ==== ", err);
        })
    }


    return (
        <Fragment>
            <li className="cntcListItem Md alignStart" key={data.userId}>
                <div className="cntcListAvtr Md">
                    {data.profilePic ?
                        <img src={data.profilePic} alt="avatar" />
                        :
                        <div className="roundimg">{data.clinicName ? data.clinicName.charAt(0) : 'C'}</div>
                    }
                </div>
                <div className="cntcListContent" onClick={() => props.handleSlide(data)}>
                    <span className="elslistTxtL">{data.clinicName ? data.clinicName : ''}</span>
                    <div className="rowBlock alignCenter">
                        <span className="elslistTxtM">{data.countryCode ? `+${data.countryCode} ` : ''}{data.phone ? data.phone?.replaceAll('+91','') : '--'}</span>

                        { /*verify && verify === true ?
                            <div className="actionItem noHover" tooltip="Verified">
                                <img src="/images/icons/verified.png" alt="icon" />
                            </div>
                            :
                            <div className="mrgLeft8">
                                <Button
                                    label={l.vfy}
                                    type='outLine'
                                    size='xs'

                                    onClick={(e) => { e.stopPropagation(); handlePopup(); }}
                                />
                        </div>*/}
                    </div>
                    <span className="elslistTxtM">{data.consultId ? `${l.clinic_id}: ${data.consultId}, ` : ''}{data.contactName ? `${l.clc_contact_name} ${data.contactName}` : ''}</span>
                </div>
                <div className="cntcListAction">
                    <div className="actionItem" onClick={() => history.push(`/admin-createusers?cId=${data.userId}`)}>
                        <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary"/>
                    </div>
                    <div className="actionItem" onClick={handleOpen}>
                        <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                    </div>

                </div>
            </li>
            {openDelete &&
                <DeleteConfirmModal header='clinic' handleDelete={handleDelete} openDelete={openDelete} closeDelete={handleOpen} data={data} msg={msg} />}
            {openPopup &&
                <VerifyPopup openVerify={openPopup} closePopup={handlePopup} handleVerify={handleVerify} phone={data.phone} />}

        </Fragment>
    )
}
export default React.memo(ClinicListItem);